export const PATHS = {
  LOGIN: 'login',
  REGISTER: 'register',
  DASHBOARD: 'stats',
  CATEGORIES: 'categories',
};
